import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="mb-4 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-edge">
    <span className="inline-block h-px w-8 bg-edge" aria-hidden="true" />
    {children}
  </p>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2
    className={`font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl ${className}`}
  >
    {children}
  </h2>
);
